import React from 'react';
import { steps } from '../data/content';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
export function StepsSection() {
  return <section id="pasos" className="border-y border-hairline bg-surface px-5 py-24 lg:px-8 lg:py-32" data-id="element-255" data-mp="1eljytewcpd08">
      <div className="mx-auto max-w-shell" data-id="element-256" data-mp="19lz1ta0qreq5">
        <Reveal data-id="element-257" data-mp="19kxfuai6t7tn">
          <h2 className="text-[32px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[44px]" data-id="element-258" data-mp="19ol4av8rz41i">
            Empieza en 3 pasos.
          </h2>
        </Reveal>

        <ol className="mt-14 space-y-px overflow-hidden rounded-3xl border border-hairline bg-hairline" data-id="element-259" data-mp="1jkeguemhuxja">
          {steps.map((step, i) => <Reveal as="li" key={step.number} delay={i * 0.07} data-id="element-260" data-mp="1taptqqo5oh2b" data-mpi={i}>
              <div className="group flex flex-col gap-3 bg-surface px-6 py-7 transition-colors duration-200 ease-smooth hover:bg-card sm:flex-row sm:items-baseline sm:gap-10 sm:px-9 sm:py-8" data-id="element-261" data-mp="1tckhsduq4pam">
                <span className="text-[26px] font-extrabold leading-none tracking-tightest text-white/15 transition-colors duration-200 ease-smooth group-hover:text-brand/70 sm:w-16" data-id="element-262" data-mp="22cz3heblo6en">
                  {step.number}
                </span>
                <div className="sm:flex-1" data-id="element-263" data-mp="2mlxgbh0yoq1j">
                  <h3 className="text-[18px] font-bold uppercase tracking-tightest text-white sm:text-[20px]" data-id="element-264" data-mp="2mk465rr53nos">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-[520px] text-[14px] leading-relaxed text-ink-muted" data-id="element-265" data-mp="2vn5bvrc3fcrx">
                    {step.description}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-266" data-mp="35cykcjgxvbry">
          <ReferralButton location="steps_section" size="lg" showArrow className="mt-10" data-id="element-267" data-mp="3ab9tst3bnk9n">
            Crear mi cuenta
          </ReferralButton>
        </Reveal>
      </div>
    </section>;
}